(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2989],{

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20});

/***/ }),

/***/ 2989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_PreviewCartTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./public/icons/installation-service.svg
/* harmony default export */ var installation_service = ({"src":"/_next/static/media/installation-service.cb6a5d61.svg","height":100,"width":100});
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
// EXTERNAL MODULE: ./components/PreviewCart/v1/index.module.scss
var index_module = __webpack_require__(18439);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/PreviewCart/v1/InstallationServiceCart.jsx










function InstallationServiceCart(param) {
    let { data ={} , currencySign , i18n , productQuantity , onQuantityChange , loading , productData , handleExceed , setLoading =()=>{} , checkoutMode  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const [quantity, setQuantity] = (0,react.useState)();
    const { isBundleChildItem , quantity: bundleInstallationQty  } = data;
    (0,react.useEffect)(()=>{
        var ref, ref1;
        setQuantity(isBundleChildItem ? bundleInstallationQty : productData === null || productData === void 0 ? void 0 : (ref = productData.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedServiceQty);
    }, [
        productData,
        data
    ]);
    const handleChange = async (qty)=>{
        setQuantity(qty);
        await onQuantityChange(data === null || data === void 0 ? void 0 : data.sku, qty, false, (0,helper.checkStock)(data.backOrder, data.category), ()=>{}, productData, data.id);
    };
    const MRPPriceObj = data === null || data === void 0 ? void 0 : (ref = data.prices) === null || ref === void 0 ? void 0 : ref.find((price)=>!price.customerGroup);
    var ref10;
    const MRPPrice = Number(((ref10 = MRPPriceObj === null || MRPPriceObj === void 0 ? void 0 : (ref1 = MRPPriceObj.value) === null || ref1 === void 0 ? void 0 : ref1.centAmount) !== null && ref10 !== void 0 ? ref10 : 0) / 100).toFixed(2);
    const MRPDiscount = Number((Number(MRPPrice) - Number(data.unitPrice)) / Number(MRPPrice) * 100).toFixed();
    var _associatedProduct;
    const installSku = (data === null || data === void 0 ? void 0 : (ref2 = data.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.isBundleChildItem) ? data.custom.fields.parentBundleSku : (_associatedProduct = data.custom.fields.associatedProduct) !== null && _associatedProduct !== void 0 ? _associatedProduct : data.sku;
    var ref11, ref12, ref13, ref14, ref15, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).installationCartWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "installation-cart-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    onError: (e)=>{
                        e.target.src = image_missing/* default.src */.Z.src;
                    },
                    src: installation_service.src,
                    alt: "",
                    className: "installation-cart-item__image"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "installation-cart-item__details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "installation-cart-item__name",
                            children: [
                                " ",
                                "Installation Service for SKU ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: installSku
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "installation-cart-item__finish",
                            children: data.desc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "installation-cart-item__footer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "installation-cart-item__qty",
                                    children: [
                                        !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                            size: "small",
                                            value: quantity,
                                            onChange: handleChange,
                                            loading: loading,
                                            productQuantity: productQuantity,
                                            handleExceed: handleExceed,
                                            setQuantity: setQuantity
                                        }),
                                        checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "preview-cart-item__qty-label",
                                            "data-testid": "prodQuantity",
                                            children: "".concat(i18n.qtyLabel, ": ").concat(data.quantity)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "installation-cart-item__price-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "installation-cart-item__price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                className: "total-price",
                                                "aria-description": i18n.total,
                                                value: data.discountPrice > 0 ? data.discountPrice * Number((ref12 = (ref11 = productData === null || productData === void 0 ? void 0 : (ref4 = productData.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.associatedServiceQty) !== null && ref11 !== void 0 ? ref11 : data.quantity) !== null && ref12 !== void 0 ? ref12 : 1) : data.unitPrice * ((ref14 = (ref13 = productData === null || productData === void 0 ? void 0 : (ref6 = productData.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.associatedServiceQty) !== null && ref13 !== void 0 ? ref13 : data.quantity) !== null && ref14 !== void 0 ? ref14 : 1),
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        }),
                                        data.discountPrice > 0 && data.discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "preview-cart-item__discount-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "preview-cart-item__offPercent",
                                                    children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "preview-cart-item__discount",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: data.unitPrice * ((ref16 = (ref15 = productData === null || productData === void 0 ? void 0 : (ref8 = productData.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.associatedServiceQty) !== null && ref15 !== void 0 ? ref15 : data.quantity) !== null && ref16 !== void 0 ? ref16 : 1),
                                                        displayType: "text",
                                                        "aria-description": i18n.strikedPrice,
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        thousandsGroupStyle: "lakh"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "installation-cart-item__remove ".concat(loading ? "--loading" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                role: "button",
                                tabIndex: "0",
                                "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                                onClick: ()=>{
                                    var ref, ref1;
                                    return isBundleChildItem ? (0,cartHelper/* breakBundleItem */.V7)(data.id) : (0,cartHelper/* removeCartItem */.B8)({
                                        ...data,
                                        quantity: productData === null || productData === void 0 ? void 0 : (ref = productData.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedServiceQty,
                                        productData
                                    });
                                },
                                children: i18n.remove
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/cart/utils.js
var utils = __webpack_require__(65875);
// EXTERNAL MODULE: ./components/PreviewCart/v1/analytics.js
var analytics = __webpack_require__(8181);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(10502);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(11310);
;// CONCATENATED MODULE: ./components/PreviewCart/v1/PreviewCartTile.jsx
















//import { cartPrerender } from "@/utils/prerender"
const PreviewCartTile = (param)=>{
    let { i18n , data , checkoutMode , currencySign , productEventInfo , presetConfigs ="" , loading , qtyLoading , setLoading =()=>{} , ...props } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [quantity, setQuantity] = (0,react.useState)(data.quantity);
    const [previewCartAlert, setPreviewCartAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [pdpUrl, setpdpUrl] = (0,react.useState)("");
    const [scene7AccountName, setScene7AccountName] = (0,react.useState)("");
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    const [isExceed, setIsExceed] = (0,react.useState)(false);
    const [installServiceData, setInstallServiceData] = (0,react.useState)({});
    const [hasInstallService, setHasInstallService] = (0,react.useState)(false);
    const { isBundleParent  } = data;
    let totalArea = "";
    let productType = "";
    let totalLabel = "";
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3, ref4;
        if (!(qtyLoading || loading)) {
            setQuantity(data.quantity);
        }
        if (data === null || data === void 0 ? void 0 : data.additionalData) setLabel();
        const isInstallService = isBundleParent ? data.bundleItems.filter((item)=>item.category === "Install Services").length : data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : ref.fields.hasOwnProperty("associatedService");
        setHasInstallService(isInstallService);
        const installServiceName = isInstallService && (data === null || data === void 0 ? void 0 : (ref1 = data.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedService);
        const tempInstallServiceData = isBundleParent ? data.bundleItems.find((item)=>item.category === "Install Services") : (ref3 = props.cartData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.products) === null || ref4 === void 0 ? void 0 : ref4.find((item)=>item.sku === installServiceName);
        setInstallServiceData(tempInstallServiceData);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            constructPdpUrl();
            const { general: { scene7AccountName ="" , swatchUrl ="" , siteName =""  }  } = config;
            setScene7AccountName(scene7AccountName);
            setSwatchUrl(swatchUrl);
            setSiteName(siteName);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!(qtyLoading || loading)) {
            setQuantity(data.quantity);
        }
    }, [
        qtyLoading,
        loading
    ]);
    const handleChange = (qty)=>{
        setQuantity(qty);
        setPreviewCartAlert({
            show: false,
            mssg: ""
        });
        var _masterVariantKey;
        props.onQuantityChange(data.sku, qty, data.isBundleParent, (0,helper.checkStock)(data.backOrder, data.category), (mssg)=>setPreviewCartAlert({
                show: true,
                mssg
            }), data, (_masterVariantKey = data.masterVariantKey) !== null && _masterVariantKey !== void 0 ? _masterVariantKey : "");
    };
    const constructPdpUrl = async ()=>{
        let pdpUrl = await (0,helper.getPDPUrl)(data.category, data.slug);
        if (data.category !== "Install Services" && data.category !== "Design Services") {
            pdpUrl = "".concat(pdpUrl).concat((pdpUrl === null || pdpUrl === void 0 ? void 0 : pdpUrl.includes("?type=part")) ? "&" : "?", "skuId=").concat(data.sku);
        }
        setpdpUrl(pdpUrl);
    };
    const handleRemoveFromCart = (data)=>{
        var ref, ref1;
        if (window.adobeDataLayer) {
            // here we need to wait for callback of API to add analytics
            // meanwhile we create productInfo and eventInfo objects and just add initialQuantity flag
            const { adobeDataLayer: { getState  } = {}  } = window;
            window.pageObj = getState && getState("page") || {};
            window.pageObj.eventInfo = {
                eventAction: "cart preview:cart update:subtract",
                eventName: "cart preview:cart update:subtract",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "cart update",
                internalLinkPosition: "cart",
                internalLinkType: "cart:removal",
                internalLinkZoneName: "cart:preview",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
            window.pageObj.productInfo = getProductInfo(data, true);
        }
        if (hasInstallService && installServiceData && (data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedServiceQty) > 0) {
            var ref2, ref3;
            const items = [
                {
                    ...installServiceData,
                    quantity: data === null || data === void 0 ? void 0 : (ref2 = data.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.associatedServiceQty
                },
                data
            ];
            (0,cartHelper/* removeLineItems */.Hy)(items, data).finally(()=>{
                setLoading(false);
            //cartPrerender()
            });
            return;
        }
        (0,cartHelper/* removeCartItem */.B8)(data, null, data.isBundleParent);
    };
    const getProductInfo = function(data) {
        let needsRemovedQuantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref, ref1;
        const { getState =()=>{}  } = window.adobeDataLayer;
        const page = getState().page;
        const siteWideCoupanCode = [];
        const productCouponCode = [];
        const discountPercents = [];
        let productCoupondiscount = 0;
        let siteWideDiscount = 0;
        let newDiscountPercentage = 0;
        if (data === null || data === void 0 ? void 0 : (ref = data.discountsList) === null || ref === void 0 ? void 0 : ref.length) {
            data === null || data === void 0 ? void 0 : data.discountsList.forEach((discountItem)=>{
                if (discountItem.type === "sitewide") {
                    var ref;
                    // always apply sitewide discount first then remaining can be applied
                    siteWideDiscount += Number(data === null || data === void 0 ? void 0 : data.unitPrice) * ((discountItem === null || discountItem === void 0 ? void 0 : discountItem.percent) / 100);
                    siteWideCoupanCode.push(discountItem === null || discountItem === void 0 ? void 0 : (ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                } else {
                    // there can be multiple product coupon codes
                    discountPercents.push(discountItem === null || discountItem === void 0 ? void 0 : discountItem.percent);
                    productCouponCode.push(discountItem === null || discountItem === void 0 ? void 0 : discountItem.code);
                }
            });
            if (discountPercents.length) {
                let priceAfterDiscount = Number(data === null || data === void 0 ? void 0 : data.unitPrice) - siteWideDiscount;
                let temporaryCouponPrice;
                for (const disc of discountPercents){
                    temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                    priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                    productCoupondiscount += temporaryCouponPrice;
                }
                productCoupondiscount = Number(productCoupondiscount.toFixed(2));
            }
        } else if (Number(data.totalBasePrice) > Number(data.unitPrice)) {
            newDiscountPercentage = (Number(data.totalBasePrice) - Number(data.unitPrice)) / Number(data.totalBasePrice) * 100;
            newDiscountPercentage = Number(newDiscountPercentage.toFixed(2));
        }
        var _productSaleable;
        return {
            productBrand: page === null || page === void 0 ? void 0 : (ref1 = page.site) === null || ref1 === void 0 ? void 0 : ref1.siteName,
            description: (0,helper.sanitizeTextForAnalytics)(data.desc) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: (data === null || data === void 0 ? void 0 : data.discountPrice) ? Number(data === null || data === void 0 ? void 0 : data.discountPrice) : Number(data === null || data === void 0 ? void 0 : data.unitPrice),
            globalDiscount: Number(data === null || data === void 0 ? void 0 : data.totalBasePrice) - Number(data === null || data === void 0 ? void 0 : data.unitPrice),
            itemType: (data === null || data === void 0 ? void 0 : data.category) || (data === null || data === void 0 ? void 0 : data.businessUnitName) || "",
            globalOffer: (siteWideCoupanCode === null || siteWideCoupanCode === void 0 ? void 0 : siteWideCoupanCode.join("|")) || "n/a",
            productCouponCode: (productCouponCode === null || productCouponCode === void 0 ? void 0 : productCouponCode.join("|")) || "n/a",
            isRecommended: false,
            isSubscription: false,
            priceState: (data === null || data === void 0 ? void 0 : data.discountPercent) > 0 || (data === null || data === void 0 ? void 0 : data.discountAmount) > 0 ? "percentOff|" + data.discountPercent : newDiscountPercentage > 0 ? "percentOff|" + newDiscountPercentage : "regular price",
            productBasePrice: Number(data === null || data === void 0 ? void 0 : data.totalBasePrice) || "n/a",
            productCategory: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.category) || "n/a",
            productColor: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.color) || "n/a",
            productCoupondiscount: productCoupondiscount || 0,
            productID: data.customerFacingSKU || data.sku || "n/a",
            productName: (0,helper.sanitizeTextForAnalytics)(data.name) || "n/a",
            productPartnerBuyNow: false,
            productRoom: (0,helper.sanitizeTextForAnalytics)(data.category) || "n/a",
            productSalePrice: data.discountPrice ? Number(data.discountPrice) || 0 : Number(data.unitPrice) || 0,
            productSaleable: (_productSaleable = data.productSaleable) !== null && _productSaleable !== void 0 ? _productSaleable : true,
            productStatus: data.availableQty >= 0 ? "in stock" : "out of stock",
            productSuperSku: data.superSku ? true : false,
            productTileName: (0,helper.sanitizeTextForAnalytics)(data.name) || "n/a",
            quantity: needsRemovedQuantity ? 0 : data.quantity,
            initialQuantity: data.quantity,
            defaultImageName: data.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (0,helper.pdpTypeFormat)({
                businessUnitName: data.businessUnitName,
                ProductIsRetail: data.ProductIsRetail,
                discontinuedProductb: data.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: data.ProductRequiredAccessoriesGroupsList,
                superSku: data.superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (0,helper.sanitizeTextForAnalytics)(data.productCollectionsName || data.category) || "n/a"
        };
    };
    const handleProductClick = ()=>{
        const productInfo = getProductInfo(data);
        (0,analytics/* callOverlayEventInfoAnalytics */.rD)(pdpUrl, productEventInfo, productInfo, data);
    };
    const setLabel = ()=>{
        if (data.additionalData.roomInfo && data.additionalData.roomInfo.length > 0) {
            const roomInfoDetails = JSON.parse(data.additionalData.roomInfo[0]);
            totalArea = roomInfoDetails.totalArea ? roomInfoDetails.totalArea : "";
            productType = roomInfoDetails.productType ? roomInfoDetails.productType : "";
            totalLabel = productType === "tile" ? i18n.squreFt : i18n.linearFt;
        }
    };
    const presetConfigsData = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imageUrl = data === null || data === void 0 ? void 0 : data.image;
    if (!isEmpty_default()(presetConfigsData) && (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) === (data === null || data === void 0 ? void 0 : (ref = data.brand) === null || ref === void 0 ? void 0 : ref.toLowerCase())) {
        const presetImageUrl = (0,helper.getPresetUrl)(width, swatchUrl, data === null || data === void 0 ? void 0 : data.image, presetConfigsData, scene7AccountName);
        imageUrl = presetImageUrl;
    }
    const handleExceed = ()=>{
        setIsExceed(true);
        setTimeout(()=>setIsExceed(false), 6000);
    };
    const MRPPriceObj = data === null || data === void 0 ? void 0 : (ref1 = data.prices) === null || ref1 === void 0 ? void 0 : ref1.find((price)=>!price.customerGroup);
    var ref8;
    const MRPPrice = data.isBundleParent ? data.bundleMRPPrice / 100 : Number(((ref8 = MRPPriceObj === null || MRPPriceObj === void 0 ? void 0 : (ref2 = MRPPriceObj.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref8 !== void 0 ? ref8 : 0) / 100).toFixed(2);
    const MRPDiscount = Number((Number(MRPPrice) - Number(data.unitPrice)) / Number(MRPPrice) * 100).toFixed();
    var _quantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.comboChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "preview-cart-item__item-of",
                children: i18n.itemOf(props.comboChild.index, props.comboChild.count)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "preview-cart-item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: pdpUrl,
                        onClick: handleProductClick,
                        "data-testid": "pdpClick",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onError: (e)=>{
                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            },
                            src: imageUrl || data.image,
                            alt: "",
                            className: "preview-cart-item__image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "preview-cart-item__details",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: pdpUrl,
                                onClick: handleProductClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "preview-cart-item__name",
                                        "data-testid": "prodName",
                                        children: checkoutMode ? data.name && data.category !== constants/* INSTALL_SERVICES */._F ? data.name + " " + data.desc : "Installation Service For SKU ".concat(data.isBundleChildItem ? data === null || data === void 0 ? void 0 : (ref3 = data.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.parentBundleSku : data === null || data === void 0 ? void 0 : data.custom.fields.associatedProduct) : data.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "preview-cart-item__header",
                                        children: data.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "preview-cart-item__brand",
                                            children: data.desc
                                        })
                                    })
                                ]
                            }),
                            data.category !== "Install Services" && data.category !== "Design Services" && data.color !== "Not Applicable" && !data.isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "preview-cart-item__finish",
                                "data-testid": "prodColor",
                                children: [
                                    i18n.colorFinish,
                                    ": ",
                                    data.color
                                ]
                            }),
                            data.isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-item__bundle-items preview-tile",
                                children: "".concat((0,utils/* getChildItemsCount */.CL)(data.bundleItems), " ").concat(i18n.items)
                            }),
                            data.isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-item__bundle-badge preview-tile",
                                children: i18n.bundle
                            }),
                            (productType === "tile" || productType === "trim") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "preview-cart-item__additional-Info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "preview-cart-item__additional-Info-label",
                                        children: [
                                            i18n === null || i18n === void 0 ? void 0 : (ref5 = i18n.total) === null || ref5 === void 0 ? void 0 : ref5.toUpperCase(),
                                            " ",
                                            totalLabel === null || totalLabel === void 0 ? void 0 : totalLabel.toUpperCase()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "preview-cart-item__additional-Info-detail",
                                        children: [
                                            ": ",
                                            totalArea
                                        ]
                                    })
                                ]
                            }),
                            previewCartAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src,
                                        alt: previewCartAlert.mssg
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: previewCartAlert.mssg
                                    })
                                ]
                            }),
                            !previewCartAlert.show && data.outOfStock && data.availableQty < 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src,
                                        alt: i18n.outOfStock
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n.outOfStock
                                    })
                                ]
                            }),
                            !previewCartAlert.show && data.outOfStock && data.availableQty > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "preview-cart-item__alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src,
                                        alt: i18n.qtyMoreThanStock(data.quantity, data.availableQty)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n.qtyMoreThanStock(data.quantity, data.availableQty)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "preview-cart-item__footer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "preview-cart-item__qty",
                                        children: !checkoutMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                            source: "cart-preview",
                                            productData: data,
                                            size: "small",
                                            value: quantity,
                                            onChange: (qty)=>handleChange(qty),
                                            loading: qtyLoading || loading,
                                            setQuantity: setQuantity
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "preview-cart-item__qty-label",
                                            "data-testid": "prodQuantity",
                                            children: "".concat(i18n.qtyLabel, ": ").concat(data.quantity)
                                        })
                                    }),
                                    !props.comboChild && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "preview-cart-item__price-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "preview-cart-item__price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: data.discountPrice > 0 ? data.discountPrice * Number((_quantity = data.quantity) !== null && _quantity !== void 0 ? _quantity : 1) : data.totalPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    "aria-description": i18n.unitPrice,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    thousandsGroupStyle: "lakh"
                                                })
                                            }),
                                            data.discountPrice > 0 && data.discountPercent > 0 && !data.isBundleChildItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "preview-cart-item__discount-container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "preview-cart-item__offPercent",
                                                        children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "preview-cart-item__discount",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                            value: data.unitPrice * data.quantity,
                                                            displayType: "text",
                                                            "aria-description": i18n.strikedPrice,
                                                            thousandSeparator: true,
                                                            prefix: currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true,
                                                            thousandsGroupStyle: "lakh"
                                                        })
                                                    })
                                                ]
                                            }),
                                            MRPPrice && MRPPrice !== data.unitPrice && data.discountPercent > 0 && !data.isBundleChildItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "preview-cart-item__discount-container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "preview-cart-item__offPercent",
                                                        children: MRPDiscount ? "".concat(MRPDiscount).concat(i18n.discountPercentage) : "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "MRP: "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "preview-cart-item__discount",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: MRPPrice * data.quantity,
                                                                    displayType: "text",
                                                                    "aria-description": i18n.strikedPrice,
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true,
                                                                    thousandsGroupStyle: "lakh"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "preview-cart-item__remove ".concat(props.loading ? "--loading" : ""),
                                onClick: ()=>(0,analytics/* addRemoveProductFromCartPreviewAnalytics */.Jh)("cmp:click", data),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                                    onClick: ()=>handleRemoveFromCart(data),
                                    "data-testid": "removeFromCart",
                                    children: i18n.remove
                                })
                            })
                        ]
                    })
                ]
            }),
            isExceed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "preview-cart-item__alert",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: warning/* default.src */.Z.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Quantity cannot be more than the product quantity"
                    })
                ]
            }),
            hasInstallService && installServiceData && (data === null || data === void 0 ? void 0 : (ref6 = data.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.associatedServiceQty) > 0 || data.isBundleParent && hasInstallService ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallationServiceCart, {
                i18n: i18n,
                loading: props.loading,
                checkoutMode: checkoutMode || checkoutMode === "share",
                data: installServiceData,
                productData: data,
                productQuantity: quantity,
                onQuantityChange: props.onQuantityChange,
                currencySign: currencySign,
                handleExceed: handleExceed,
                setLoading: setLoading
            }, installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.id) : null
        ]
    });
};
/* harmony default export */ var v1_PreviewCartTile = (PreviewCartTile);


/***/ }),

/***/ 8181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ addRemoveProductFromCartPreviewAnalytics; },
/* harmony export */   "lq": function() { return /* binding */ continueShoppingPreviewAnalytics; },
/* harmony export */   "oV": function() { return /* binding */ viewCheckoutPreviewAnalytics; },
/* harmony export */   "rD": function() { return /* binding */ callOverlayEventInfoAnalytics; },
/* harmony export */   "sP": function() { return /* binding */ viewCartPreviewAnalytics; }
/* harmony export */ });
/* unused harmony export getCustomAnalyticsData */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const callOverlayEventInfoAnalytics = function() {
    let pdpUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productEventInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const overlayEventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart overlay:product navigation",
        eventMsg: "n/a",
        eventName: "cart overlay:product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(data.name),
        internalLinkPosition: "cart overlay",
        internalLinkType: "cart overlay:navigation",
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(pdpUrl),
        internalLinkZoneName: "cart:overlay"
    };
    if (window.adobeDataLayer || productEventInfo) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = productEventInfo ? JSON.parse(productEventInfo) : overlayEventInfo;
        eventInfo.internalLinkURL = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(pdpUrl);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            productInfo,
            page
        });
    }
};
const addRemoveProductFromCartPreviewAnalytics = (action, data)=>{
    var ref, ref1, ref2, ref3;
    const eventInfo = {
        eventAction: "cart preview:cart update:remove",
        eventName: "cart preview:cart update:remove",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "cart update",
        internalLinkPosition: "cart",
        internalLinkType: "cart:removal",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    sessionStorage.setItem("cartLanding", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const removedItem = page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.productInfo.productID === data.sku);
    const updatedPage = page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>{
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== data.sku;
    });
    if (page && page.cart && page.cart.item) {
        page.cart.item = updatedPage;
    }
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: removedItem === null || removedItem === void 0 ? void 0 : removedItem.productInfo
    });
};
const viewCartPreviewAnalytics = (action, linkUrl)=>{
    const eventInfo = {
        eventAction: "cart:preview:view cart",
        eventName: "cart:preview:view cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view cart",
        internalLinkPosition: "cart preview",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(linkUrl),
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo
    });
};
const viewCheckoutPreviewAnalytics = (action, linkUrl)=>{
    const eventInfo = {
        eventAction: "cart:preview:checkout",
        eventName: "cart:preview:checkout",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "checkout",
        internalLinkPosition: "cart preview",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(linkUrl),
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo
    });
};
const continueShoppingPreviewAnalytics = (action)=>{
    const eventInfo = {
        eventAction: "cart:preview:continue shopping",
        eventName: "cart:preview:continue shopping",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "continue shopping",
        internalLinkPosition: "cart preview",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo
    });
};
const getCustomAnalyticsData = function() {
    let cartAnalytics = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cartID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", subtotal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const { item  } = cartAnalytics;
    return JSON.stringify({
        cart: {
            cartID: cartID,
            price: subtotal,
            items: item
        }
    });
};


/***/ }),

/***/ 18439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"installationCartWrapper":"v1_installationCartWrapper__V_Ldd"};

/***/ })

}]);